import { AppService } from './../../services/app.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { NAVBAR_COMPONENTS, NAVBAR_MORE_COMPONENTS } from '../../constants/navbar-config';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  animations: [trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate(760)])])],
  host: {
    '(window:resize)': 'onResize($event)',
  },
})
export class NavbarComponent implements OnInit, OnChanges, OnDestroy {
  activePath: string;
  navbarComponents = [...NAVBAR_COMPONENTS];
  navbarMoreComponents = [...NAVBAR_MORE_COMPONENTS];
  private roleChangeSub: Subscription;
  isMoreExpanded = false;
  isNavbarVisible: boolean = true;
  hyperLinkStyle: any;
  hyperNavStyle: any;
  smallClass: any;
  hyperLinkPadding: any;
  hyperLinkFontSize: any;
  hyperLinkLineHeight: any;
  navigateFromDash: boolean = false;
  previousUrl: any;
  currentUrl: string;
  mobile: boolean;
  userRole: string;
  user: any;
  @Input() showHideToggle: string;

  constructor(
    private router: Router,
    private appService: AppService,
    private location: Location,
    private authService: AuthService
  ) {
    this.currentUrl = this.router.url;
    this.previousUrl = null;
    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.urlAfterRedirects;
      if (this.previousUrl === '/dashboard') {
        this.navigateFromDash = true;
      } else this.navigateFromDash = false;
    });
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.init();
  }

  toggleMore(): void {
    this.isMoreExpanded = !this.isMoreExpanded;
  }

  async init(): Promise<void> {
    this.userRole = JSON.parse(localStorage.getItem('role'));;
    this.filterNavByRole(this.userRole);

    this.roleChangeSub = this.authService.roleChanged$.subscribe((newRole) => {
      if (newRole) {
        this.userRole = newRole;
        this.navbarComponents = [...NAVBAR_COMPONENTS];
        this.navbarMoreComponents = [...NAVBAR_MORE_COMPONENTS];
        this.filterNavByRole(newRole);
      }
    });

    this.setActiveClass();
    this.appService.isNavbarVisible.subscribe((flag: boolean) => {
      this.isNavbarVisible = flag;
    });

    this.mobile = window.innerWidth <= 767;
  }

  ngOnDestroy(): void {
    if (this.roleChangeSub) {
      this.roleChangeSub.unsubscribe();
    }
  }

  filterNavByRole(role: string): void {
    switch (role) {
      case 'practice_admin_sante_community': {
        if (this.user?.email === 'cmpwest@santehealth.net') {
          this.navbarComponents = this.navbarComponents.filter(
            (comp) => comp.title === 'Messages'
          );
          this.navbarMoreComponents = this.navbarMoreComponents.filter(
            (comp) => comp.title === 'Appointments Report' || comp.title === 'SMS Scripts'
          );
          break;
        }
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Messages'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) => comp.title === 'User Management' || comp.title === 'Appointments Report' || comp.title === 'SMS Scripts'
        );
        break;
      }
      case 'practice_admin_sante_community_order': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Messages' || comp.title === 'Order Management'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) => comp.title === 'User Management' || comp.title === 'Appointments Report' || comp.title === 'SMS Scripts'
        );
        break;
      }
      case 'practice_user_sante_community': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Messages'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) => comp.title === 'Appointments Report'
        );
        break;
      }
      case 'practice_user_sante_community_order': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Messages' || comp.title === 'Order Management'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) => comp.title === 'Appointments Report'
        );
        break;
      }
      case 'location_admin': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Order Management'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) => comp.title === 'User Management'
        );
        break;
      }
      case 'location_user': {
         this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Order Management'
        );
        this.navbarMoreComponents = [];
        break;
      }
      case 'practice_benefits': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Order Management'
        );
        this.navbarMoreComponents = [];
        break;
      }
      case 'practice_scribe': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Audio Dictation'
        );
        // this.navbarMoreComponents = this.navbarMoreComponents.filter(
        //   (comp) => comp.title === 'Video Dictation' || comp.title === 'Transcriptions'
        // );
        break;
      }
      case 'practice_general_user': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Audio Dictation' || comp.title === 'Order Management' || comp.title === 'Messages'
        );
        // this.navbarMoreComponents = this.navbarMoreComponents.filter(
        //   (comp) => comp.title === 'Video Dictation' || comp.title === 'Transcriptions'
        // );
        break;
      }
      case 'practice_admin': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) =>
            comp.title === 'Dashboard' ||
            comp.title === 'Audio Dictation' ||
            comp.title === 'Order Management' ||
            comp.title === 'Messages' ||
            comp.title === 'Statements' ||
            comp.title === 'Payments' ||
            comp.title === 'Payer Benefits' ||
            comp.title === 'Automation'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) =>
            comp.title === 'Automation Activity' ||
            comp.title === 'Unlock Codes' ||
            comp.title === 'Activity Logs' ||
            comp.title === 'User Management' ||
            comp.title === 'Video Dictation' ||
            comp.title === 'Content Management' ||
            comp.title === 'Forms' ||
            // comp.title === 'Transcriptions' ||
            comp.title === 'Appointments Report' ||
            comp.title === 'SMS Scripts' ||
            comp.title === 'Branding' ||
            comp.title === 'Insurance Forms' ||
            comp.title === 'Downloads'
        );
        break;
      }
      case 'practice_message_user': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Messages'
        );
        this.navbarMoreComponents = [];
        break;
      }
      case 'practice_message_admin': {
        this.navbarComponents = this.navbarComponents.filter(
          (comp) => comp.title === 'Messages'
        );
        this.navbarMoreComponents = this.navbarMoreComponents.filter(
          (comp) => comp.title === 'User Management'
        );
        break;
      }
      default:
        // For an empty userRole or any other unmatched value
        this.navbarComponents = [];
        this.navbarMoreComponents = [];
        break;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showHideToggle && changes.showHideToggle.currentValue) {
      this.hyperLinkPadding = '3px 15px';
      this.hyperLinkFontSize = '10px';
      this.hyperLinkLineHeight = '12px';
      // this.hyperLinkStyle = 'padding: 3px 15px, font-size: 10px, line-height: 12px;';
      this.hyperNavStyle =
        ' min-width: 100px; max-width: 100px;width: 100%; text-align: center;margin-left: 0 !important;';
      this.smallClass = 'display:block;font-size: 10px;width: 100%;';
    } else {
      this.hyperLinkPadding = '';
      this.hyperLinkFontSize = '';
      this.hyperLinkLineHeight = '';
      // this.hyperLinkStyle = '';
      this.hyperNavStyle = '';
      this.smallClass = '';
    }
  }

  setActiveClass(): void {
    if (this.userRole === 'location_admin' && this.router.url === '/dashboard') {
      this.activePath = '/dashboard/orders';
    } else if (
      (this.userRole === 'location_user' || this.userRole === 'practice_benefits') &&
      this.router.url === '/dashboard'
    ) {
      this.activePath = '/dashboard/orders';
    } else if (this.userRole === 'practice_scribe' && this.router.url === '/dashboard') {
      this.activePath = '/dashboard/video-dictation';
    } else if (this.router.url === '/') {
      this.activePath = '/dashboard';
    } else {
      this.activePath = this.router.url;
    }
  }

  onResize(event) {
    const width = event.target.innerWidth;
    this.mobile = width <= 767;
  }

  get checkUrl(): boolean {
    return false;
  }
}
